export const ospekFakData = [
   {
      nama: "Fakultas Ilmu Komputer",
      waktu: "21 Agustus 2021 & 22 Agustus 2021",
      web: "https://simaba-filkom.ub.ac.id/",
      instgram: "https://www.instagram.com/pk2maba_filkom/"
   },
   {
      nama: "Fakultas Ekonomi dan Bisnis",
      waktu: "21 Agustus 2021 & 22 Agustus 2021",
      web: "http://pkkmaba.feb.ub.ac.id/",
      instgram: "https://www.instagram.com/alterationfebub/"
   },
   {
      nama: "Fakultas Ilmu Administrasi",
      waktu: "",
      web: "",
      instgram: "https://www.instagram.com/pkkmb_fiaub/"
   },
   {
      nama: "Fakultas Hukum",
      waktu: "",
      web: "https://hukum.ub.ac.id/",
      instgram: "https://www.instagram.com/pk2maba.fhub/"
   },
   {
      nama: "Fakultas Kedokteran",
      waktu: "21 Agustus 2021 & 22 Agustus 2021",
      web: "",
      instgram: "https://www.instagram.com/probinmabafkub/"
   },
   {
      nama: "Fakultas Kedokteran Gigi",
      waktu: "20 Agustus 2021 & 21 Agustus 2021",
      web: "",
      instgram: "https://www.instagram.com/probinmabafkgub/"
   },
   {
      nama: "Fakultas Kedokteran Hewan",
      waktu: "21 Agustus 2021 & 22 Agustus 2021",
      web: "",
      instgram: "https://www.instagram.com/maba_fkhubofficial/"
   },
   {
      nama: "Fakultas Teknik",
      waktu: "21 Agustus 2021 & 22 Agustus 2021",
      web: "-",
      instgram: ""
   },
   {
      nama: "Fakultas Ilmu Budaya",
      waktu: "21 Agustus 2021 & 22 Agustus 2021",
      web: "https://pkkmabafibub.com",
      instgram: "https://www.instagram.com/pkkmabafibub/"
   },
   {
      nama: "Fakultas Perikanan dan Ilmu Kelautan",
      waktu: "21 Agustus 2021 & 22 Agustus 2021",
      web: "https://pik.ub.ac.id/category/pkkmaba/",
      instgram: "https://www.instagram.com/pinishi2021/"
   },
   {
      nama: "Fakultas Ilmu Sosial dan Politik",
      waktu: "21 Agustus 2021 & 22 Agustus 2021",
      web: "https://www.fisip.ub.ac.id",
      instgram: "https://www.instagram.com/pkkmaba.fisipub/"
   },
   {
      nama: "Fakultas Pertanian",
      waktu: "",
      web: "",
      instgram: "https://www.instagram.com/posterfpub/"
   },
   {
      nama: "Fakultas Peternakan",
      waktu: "",
      web: "https://fapet.ub.ac.id",
      instgram: "https://www.instagram.com/maba_fapetub/"
   },
   {
      nama: "Fakultas Teknologi Pertanian",
      waktu: "21 Agustus 2021 & 22 Agustus 2021",
      web: "https://pkkftp.tp.ub.ac.id",
      instgram: "https://www.instagram.com/rajawaliftpub/"
   },
   {
      nama: "PSDKU UB Kediri",
      waktu: "21 Agustus 2021 & 22 Agustus 2021",
      web: "",
      instgram: "https://www.instagram.com/official_pkkmbpsdkuub/"
   },
   {
      nama: "Fakultas Matematika dan Ilmu Pengetahuan Alam",
      waktu: "",
      web: "http://mipa.ub.ac.id/ ",
      instgram: "https://www.instagram.com/probinmabafmipa/"
   },
   {
      nama: "Pendidikan Vokasi",
      waktu: "21 Agustus 2021 & 22 Agustus 2021",
      web: "http://yuwaraja.vokasi.ub.ac.id/",
      instgram: "https://www.instagram.com/pkkmb_vokasiub/"
   },
]